export const URL = {
  ZENDESK: 'https://help.hotmart.com'
};

export const ENV = {
  PRODUCTION: 'prod',
  STAGING: 'dev',
  LOCAL: 'local'
};

export const BREAKPOINTS = {
  XS: 576,
  SM: 768,
  MD: 992,
  LG: 1366,
  XL: 1536,
  DEFAULT: 'default'
};

export const USER_ROLE = {
  STUDENT: 'STUDENT',
  OWNER: 'OWNER',
  FREE_STUDENT: 'FREE_STUDENT',
  ADMIN: 'ADMIN',
  CONTENT_EDITOR: 'CONTENT_EDITOR',
  MODERATOR: 'MODERATOR'
};

export const LOCALES = {
  AR: 'AR',
  DE: 'DE',
  EN: 'EN',
  ES: 'ES',
  FR: 'FR',
  IT: 'IT',
  PT_BR: 'PT_BR',
  JA: 'JA'
};

export const ZENDESK_LOCALE = {
  [LOCALES.AR]: 'ar',
  [LOCALES.EN]: 'en',
  [LOCALES.ES]: 'es',
  [LOCALES.FR]: 'fr',
  [LOCALES.IT]: 'it',
  [LOCALES.JA]: 'ja',
  [LOCALES.AR]: 'ar',
  [LOCALES.PT_BR]: 'pt-BR'
};
